(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["belvaur-color-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    function dedupe() {
      document.querySelectorAll('.product__info-container').forEach(function (container) {
        var rows = container.querySelectorAll('.belvaur-swatches');
        for (var i = 1; i < rows.length; i++) { rows[i].remove(); }
      });
    }
    if (document.readyState !== 'loading') { dedupe(); }
    else { document.addEventListener('DOMContentLoaded', dedupe); }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["belvaur-notify"] && !Shopify.designMode) return;
  try {
    (function () {
    function dedupe() {
      document.querySelectorAll('.product__info-container').forEach(function (c) {
        var n = c.querySelectorAll('.belvaur-notify');
        for (var i = 1; i < n.length; i++) { n[i].remove(); }
      });
    }
    function wire() {
      document.querySelectorAll('.belvaur-notify').forEach(function (box) {
        if (box.dataset.wired) return; box.dataset.wired = '1';
        var toggle = box.querySelector('.belvaur-notify__toggle');
        var form = box.querySelector('.belvaur-notify__form');
        var email = box.querySelector('.belvaur-notify__email');
        var submit = box.querySelector('.belvaur-notify__submit');
        var msg = box.querySelector('.belvaur-notify__msg');
        var row = box.querySelector('.belvaur-notify__row');
        if (toggle) toggle.addEventListener('click', function () {
          form.hidden = !form.hidden;
          if (!form.hidden && email) email.focus();
        });
        function send() {
          if (!email || !email.value || email.validity.valid === false) { if (email) email.reportValidity(); return; }
          var fd = new FormData();
          fd.append('form_type', 'contact');
          fd.append('utf8', '✓');
          fd.append('contact[email]', email.value);
          fd.append('contact[body]', 'BACK-IN-STOCK request for: ' + (box.dataset.product || '') + ' — ' + (box.dataset.url || ''));
          if (submit) submit.disabled = true;
          fetch('/contact', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
            .then(function (r) {
              msg.hidden = false;
              if (r.ok || r.status === 0 || r.type === 'opaqueredirect') {
                msg.textContent = "You're on the list — we'll email you when it's available.";
                msg.className = 'belvaur-notify__msg is-ok';
                if (row) row.style.display = 'none';
              } else {
                msg.textContent = 'Something went wrong — please try again.';
                msg.className = 'belvaur-notify__msg is-err';
                if (submit) submit.disabled = false;
              }
            })
            .catch(function () {
              msg.hidden = false;
              msg.textContent = 'Something went wrong — please try again.';
              msg.className = 'belvaur-notify__msg is-err';
              if (submit) submit.disabled = false;
            });
        }
        if (submit) submit.addEventListener('click', send);
        if (email) email.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); send(); } });
      });
    }
    function init() { dedupe(); wire(); }
    if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["belvaur-preorder"] && !Shopify.designMode) return;
  try {
    (function(){
    function dedupe(){
      document.querySelectorAll('.product__info-container').forEach(function(c){
        var n=c.querySelectorAll('.belvaur-po');
        for(var i=1;i<n.length;i++){ n[i].remove(); }
      });
    }
    function wire(){
      document.querySelectorAll('.belvaur-po').forEach(function(box){
        if(box.dataset.wired) return; box.dataset.wired='1';
        var open=box.querySelector('.belvaur-po__open');
        var overlay=box.querySelector('.belvaur-po__overlay');
        var close=box.querySelector('.belvaur-po__close');
        var picks=box.querySelectorAll('.belvaur-po__pick');
        var add=box.querySelector('.belvaur-po__add');
        var msg=box.querySelector('.belvaur-po__msg');
        var chosen=null;
        function openM(){ if(overlay.parentNode!==document.body){ document.body.appendChild(overlay); } overlay.hidden=false; document.body.style.overflow='hidden'; }
        function closeM(){ overlay.hidden=true; document.body.style.overflow=''; }
        if(open) open.addEventListener('click', openM);
        if(close) close.addEventListener('click', closeM);
        if(overlay) overlay.addEventListener('click', function(e){ if(e.target===overlay) closeM(); });
        picks.forEach(function(p){
          p.addEventListener('click', function(){
            picks.forEach(function(x){ x.classList.remove('is-selected'); });
            p.classList.add('is-selected');
            chosen=p.dataset.variant;
            add.disabled=false; add.textContent='Add bundle to cart';
          });
        });
        if(add) add.addEventListener('click', function(){
          if(!chosen) return;
          add.disabled=true; add.textContent='Adding…';
          fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(box.dataset.current,10),quantity:1},{id:parseInt(chosen,10),quantity:1}]})})
            .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
            .then(function(){ window.location.href='/cart'; })
            .catch(function(){ if(msg){ msg.hidden=false; msg.textContent='Could not add to cart — please try again.'; msg.className='belvaur-po__msg is-err'; } add.disabled=false; add.textContent='Add bundle to cart'; });
        });
        document.addEventListener('keydown', function(e){ if(e.key==='Escape' && overlay && !overlay.hidden) closeM(); });
      });
    }
    function init(){ dedupe(); wire(); }
    if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  })();
  } catch(e) { console.error(e); }
})();

})();
